var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor create-task" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("İş Akışı")]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.workflows,
              idKey: "_id",
              labelKey: "title",
              placeholder: "İş Akışı Seçin",
            },
            model: {
              value: _vm.clone.workflowId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "workflowId", $$v)
              },
              expression: "clone.workflowId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Pipeline Aşaması")]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.filteredPipelineStages,
              idKey: "_id",
              labelKey: "name",
              placeholder: "Pipeline Aşaması Seçin",
            },
            model: {
              value: _vm.clone.pipelineStageId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "pipelineStageId", $$v)
              },
              expression: "clone.pipelineStageId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Başlık")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Görev Başlığı",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.title,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "title", $$v)
              },
              expression: "clone.title",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Açıklama")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Görev Açıklaması",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.description,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "description", $$v)
              },
              expression: "clone.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Öncelik")]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.priorityOptions,
              idKey: "value",
              labelKey: "label",
              placeholder: "Öncelik Seçin",
            },
            model: {
              value: _vm.clone.priority,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "priority", $$v)
              },
              expression: "clone.priority",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Atananlar")]),
          _vm._v(" "),
          _vm._l(_vm.clone.assigneeIds, function (assignee, index) {
            return _c(
              "div",
              { key: index, staticClass: "dynamic-field" },
              [
                _c(
                  "div",
                  { staticClass: "field-header" },
                  [
                    _c("span", [_vm._v("Atanan " + _vm._s(index + 1))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mode-switch" },
                      [
                        _c("span", { staticClass: "switch-label" }, [
                          _vm._v("Dinamik"),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: assignee.mode === "dynamic",
                          },
                          on: {
                            change: function (checked) {
                              return _vm.onModeChange(checked, assignee)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { icon: "", danger: "", xsmall: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeAssignee(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                assignee.mode === "static"
                  ? [
                      _c("CustomPicker", {
                        attrs: {
                          items: _vm.userOptions,
                          idKey: "_id",
                          labelKey: "name",
                          placeholder: "Kullanıcı Seçin",
                        },
                        model: {
                          value: assignee.value,
                          callback: function ($$v) {
                            _vm.$set(assignee, "value", $$v)
                          },
                          expression: "assignee.value",
                        },
                      }),
                    ]
                  : [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: "Dinamik Değer",
                          "show-attributes": true,
                          "automation-mode": "",
                        },
                        model: {
                          value: assignee.value,
                          callback: function ($$v) {
                            _vm.$set(assignee, "value", $$v)
                          },
                          expression: "assignee.value",
                        },
                      }),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addAssignee },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v("\n                Atanan Ekle\n            "),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Takipçiler")]),
          _vm._v(" "),
          _vm._l(_vm.clone.followers, function (follower, index) {
            return _c(
              "div",
              { key: index, staticClass: "dynamic-field" },
              [
                _c(
                  "div",
                  { staticClass: "field-header" },
                  [
                    _c("span", [_vm._v("Takipçi " + _vm._s(index + 1))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mode-switch" },
                      [
                        _c("span", { staticClass: "switch-label" }, [
                          _vm._v("Dinamik"),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: follower.mode === "dynamic",
                          },
                          on: {
                            change: function (checked) {
                              return _vm.onFollowerModeChange(checked, follower)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { icon: "", danger: "", xsmall: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeFollower(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                follower.mode === "static"
                  ? [
                      _c("CustomPicker", {
                        attrs: {
                          items: _vm.userOptions,
                          idKey: "_id",
                          labelKey: "name",
                          placeholder: "Takipçi Seçin",
                        },
                        model: {
                          value: follower.value,
                          callback: function ($$v) {
                            _vm.$set(follower, "value", $$v)
                          },
                          expression: "follower.value",
                        },
                      }),
                    ]
                  : [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: "Dinamik Değer",
                          "show-attributes": true,
                          "automation-mode": "",
                        },
                        model: {
                          value: follower.value,
                          callback: function ($$v) {
                            _vm.$set(follower, "value", $$v)
                          },
                          expression: "follower.value",
                        },
                      }),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addFollower },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v("\n                Takipçi Ekle\n            "),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("İşbirlikçiler")]),
          _vm._v(" "),
          _vm._l(_vm.clone.collaborators, function (collaborator, index) {
            return _c(
              "div",
              { key: index, staticClass: "dynamic-field" },
              [
                _c(
                  "div",
                  { staticClass: "field-header" },
                  [
                    _c("span", [_vm._v("İşbirlikçi " + _vm._s(index + 1))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mode-switch" },
                      [
                        _c("span", { staticClass: "switch-label" }, [
                          _vm._v("Dinamik"),
                        ]),
                        _vm._v(" "),
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: collaborator.mode === "dynamic",
                          },
                          on: {
                            change: function (checked) {
                              return _vm.onCollaboratorModeChange(
                                checked,
                                collaborator
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { icon: "", danger: "", xsmall: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeCollaborator(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                collaborator.mode === "static"
                  ? [
                      _c("CustomPicker", {
                        attrs: {
                          items: _vm.userOptions,
                          idKey: "_id",
                          labelKey: "name",
                          placeholder: "İşbirlikçi Seçin",
                        },
                        model: {
                          value: collaborator.value,
                          callback: function ($$v) {
                            _vm.$set(collaborator, "value", $$v)
                          },
                          expression: "collaborator.value",
                        },
                      }),
                    ]
                  : [
                      _c("TiptapEditor", {
                        attrs: {
                          placeholder: "Dinamik Değer",
                          "show-attributes": true,
                          "automation-mode": "",
                        },
                        model: {
                          value: collaborator.value,
                          callback: function ($$v) {
                            _vm.$set(collaborator, "value", $$v)
                          },
                          expression: "collaborator.value",
                        },
                      }),
                    ],
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addCollaborator },
            },
            [
              _c("a-icon", { attrs: { type: "plus" } }),
              _vm._v("\n                İşbirlikçi Ekle\n            "),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [_vm._v("Sahip")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dynamic-field" },
          [
            _c("div", { staticClass: "field-header" }, [
              _c(
                "div",
                { staticClass: "mode-switch" },
                [
                  _c("span", { staticClass: "switch-label" }, [
                    _vm._v("Dinamik"),
                  ]),
                  _vm._v(" "),
                  _c("a-switch", {
                    attrs: {
                      size: "small",
                      checked: _vm.clone.ownerId.mode === "dynamic",
                    },
                    on: {
                      change: function (checked) {
                        return _vm.onOwnerModeChange(checked)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.clone.ownerId.mode === "static"
              ? [
                  _c("CustomPicker", {
                    attrs: {
                      items: _vm.userOptions,
                      idKey: "_id",
                      labelKey: "name",
                      placeholder: "Sahip Seçin",
                    },
                    model: {
                      value: _vm.clone.ownerId.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.ownerId, "value", $$v)
                      },
                      expression: "clone.ownerId.value",
                    },
                  }),
                ]
              : [
                  _c("TiptapEditor", {
                    attrs: {
                      placeholder: "Sahip ID'si gir",
                      "show-attributes": true,
                      "automation-mode": "",
                    },
                    model: {
                      value: _vm.clone.ownerId.value,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.ownerId, "value", $$v)
                      },
                      expression: "clone.ownerId.value",
                    },
                  }),
                ],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Contact ID")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Contact ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.contactId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "contactId", $$v)
              },
              expression: "clone.contactId",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }